'use strict';

var classNames = require('classnames');
require('prop-types');
var React = require('react');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var AlternateButton = require('../../library/Buttons/AlternateButton.js');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  planName: {
    color: 'inherit',
    fontSize: '50px'
  },
  closeText: {
    lineHeight: 1
  },
  pricingSpacing: {
    margin: '20px 0'
  },
  contentSpacing: {
    margin: 10
  }
};

var customStyles = function customStyles(theme) {
  return {
    button: {
      minHeight: '200px'
    }
  };
};

var CustomAlternateButton = withStyles(customStyles)(AlternateButton);

function PricingButton(_ref) {
  var classes = _ref.classes,
      onClick = _ref.onClick,
      selectedPlan = _ref.selectedPlan,
      selected = _ref.selected;
  var display_name = selectedPlan.display_name,
      plan_descriptions = selectedPlan.plan_descriptions,
      price = selectedPlan.price;
  return React__default["default"].createElement(CustomAlternateButton, {
    selected: selected,
    onClick: onClick
  }, React__default["default"].createElement(Grid, {
    container: true,
    className: classes.contentSpacing
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.closeText
  }, React__default["default"].createElement(Typography, {
    className: classes.planName,
    variant: "h3"
  }, display_name)), !!price && React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement("div", {
    className: classes.pricingSpacing
  }, React__default["default"].createElement(Typography, {
    className: classNames__default["default"](classes.inheritFontColor, classes.closeText),
    variant: "h1",
    component: "p"
  }, "$".concat(price / 100)), React__default["default"].createElement(Typography, {
    className: classNames__default["default"](classes.inheritFontColor, classes.closeText),
    variant: "body1"
  }, "per month"))), plan_descriptions.map(function (plan_description, index) {
    return React__default["default"].createElement(Grid, {
      item: true,
      xs: 12,
      key: index,
      className: classes.closeText
    }, React__default["default"].createElement(Typography, {
      className: classNames__default["default"](classes.inheritFontColor),
      variant: "body1"
    }, plan_description));
  })));
}

PricingButton.defaultProps = {
  onClick: function onClick() {}
};
var PricingButton$1 = withStyles(styles)(PricingButton);

module.exports = PricingButton$1;
